import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/app/share/[uuid]/content.tsx");
